import type { Client } from '@efdigital/ll-addon-data';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    client: Client;
    uniqueId: string;
    isReadOnly: boolean;
  };
}

class BrandingSection extends Component<Signature> {
  setBranding = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.args.client.branding = target.value;
  };

  <template>
    <h3 class="gud-eyebrow">Branding</h3>
    <fieldset disabled={{@isReadOnly}} class="mb-4">
      <div class="mb-3">
        <label for="{{@uniqueId}}-branding" class="form-label">Branding
          identifier</label>
        <input
          id="{{@uniqueId}}-branding"
          name="branding"
          type="text"
          class="form-control"
          value={{@client.branding}}
          {{on "change" this.setBranding}}
          placeholder="Branding identifier"
        />
        <div class="form-text">
          If the client requires custom branding (colors, logo, etc.), this will
          be implemented by developers in the digital team.<br />
          They will provide a branding identifier which can be applied here.
        </div>
      </div>
    </fieldset>
  </template>
}

export default BrandingSection;
